/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnactive2Inputs */

const en_partnerscolumnactive2 = /** @type {(inputs: Partnerscolumnactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const de_partnerscolumnactive2 = /** @type {(inputs: Partnerscolumnactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Partnerscolumnactive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnactive2 = /** @type {((inputs?: Partnerscolumnactive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnactive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnactive2(inputs)
	return de_partnerscolumnactive2(inputs)
});
export { partnerscolumnactive2 as "partnersColumnActive" }